import {
  TablePage,
  AddPage,
  EditPage,
  ViewPage,
} from 'src/views/aceocean/vesselmaster'
import pathMap from 'src/paths/pathMap'

class AceOcnVesselMasterRoute {
  getConfigurations() {
    return [
      {
        exact: true,
        path: pathMap.ACE_OCN_VESSEL_MASTER_LIST_VIEW,
        component: TablePage
      },
      {
        exact: true,
        path: pathMap.ACE_OCN_VESSEL_MASTER_ADD_VIEW,
        component: AddPage
      },
      {
        exact: true,
        path: pathMap.ACE_OCN_VESSEL_MASTER_EDIT_VIEW,
        component: EditPage
      },
      {
        exact: true,
        path: pathMap.ACE_OCN_VESSEL_MASTER_DETAILS_VIEW,
        component: ViewPage
      }
    ]
  }
}

export default AceOcnVesselMasterRoute
